import { render, staticRenderFns } from "./CloButton.vue?vue&type=template&id=bdece908&"
import script from "./CloButton.vue?vue&type=script&lang=js&"
export * from "./CloButton.vue?vue&type=script&lang=js&"
import style0 from "./CloButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports